import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SharedModule } from '@shared/shared.module';

import { UserCardComponent } from './components/user-card/user-card.component';
import { UserCreationComponent } from './components/user-creation/user-creation.component';
import { UserEditComponent } from './components/user-edit/user-edit.component';
import { UsersComponent } from './components/users/users.component';
import { MerchantAccountRoutingModule } from './merchant-account-routing.module';
import { MerchantAccountEffects } from './store/merchant-account.effects';
import { MerchantAccountFeature } from './store/merchant-account.slice';

@NgModule({
  declarations: [
    UsersComponent,
    UserCardComponent,
    UserEditComponent,
    UserCreationComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MerchantAccountRoutingModule,
    StoreModule.forFeature(MerchantAccountFeature),
    EffectsModule.forFeature([MerchantAccountEffects]),
  ],
})
export class MerchantAccountModule {}
